import { create } from "zustand";
var useSearchStore = create(function (set, get) { return ({
    applySearch: function (_a) {
        var codigoInep = _a.codigoInep, codigoInscricao = _a.codigoInscricao, cpf = _a.cpf, dataNascimento = _a.dataNascimento, tipoInscricao = _a.tipoInscricao;
        return set({
            codigoInep: codigoInep,
            codigoInscricao: codigoInscricao,
            cpf: cpf,
            dataNascimento: dataNascimento,
            tipoInscricao: tipoInscricao,
        });
    },
    resetSearch: function () {
        return set({
            tipoInscricao: undefined,
            cpf: undefined,
            codigoInscricao: undefined,
            dataNascimento: undefined,
            codigoInep: undefined,
        });
    },
    hasAnyFilter: function () {
        var _a, _b, _c, _d, _e;
        return Boolean((((_a = get()) === null || _a === void 0 ? void 0 : _a.codigoInscricao) && ((_b = get()) === null || _b === void 0 ? void 0 : _b.cpf) && ((_c = get()) === null || _c === void 0 ? void 0 : _c.dataNascimento)) ||
            (((_d = get()) === null || _d === void 0 ? void 0 : _d.codigoInep) && ((_e = get()) === null || _e === void 0 ? void 0 : _e.codigoInscricao)));
    },
}); });
export default useSearchStore;
